var map = {
	"./[NO]@2x.png": "./src/assets/emoji/[NO]@2x.png",
	"./[OK]@2x.png": "./src/assets/emoji/[OK]@2x.png",
	"./[下雨]@2x.png": "./src/assets/emoji/[下雨]@2x.png",
	"./[么么哒]@2x.png": "./src/assets/emoji/[么么哒]@2x.png",
	"./[乒乓]@2x.png": "./src/assets/emoji/[乒乓]@2x.png",
	"./[便便]@2x.png": "./src/assets/emoji/[便便]@2x.png",
	"./[信封]@2x.png": "./src/assets/emoji/[信封]@2x.png",
	"./[偷笑]@2x.png": "./src/assets/emoji/[偷笑]@2x.png",
	"./[傲慢]@2x.png": "./src/assets/emoji/[傲慢]@2x.png",
	"./[再见]@2x.png": "./src/assets/emoji/[再见]@2x.png",
	"./[冷汗]@2x.png": "./src/assets/emoji/[冷汗]@2x.png",
	"./[凋谢]@2x.png": "./src/assets/emoji/[凋谢]@2x.png",
	"./[刀]@2x.png": "./src/assets/emoji/[刀]@2x.png",
	"./[删除]@2x.png": "./src/assets/emoji/[删除]@2x.png",
	"./[勾引]@2x.png": "./src/assets/emoji/[勾引]@2x.png",
	"./[发呆]@2x.png": "./src/assets/emoji/[发呆]@2x.png",
	"./[发抖]@2x.png": "./src/assets/emoji/[发抖]@2x.png",
	"./[可怜]@2x.png": "./src/assets/emoji/[可怜]@2x.png",
	"./[可爱]@2x.png": "./src/assets/emoji/[可爱]@2x.png",
	"./[右哼哼]@2x.png": "./src/assets/emoji/[右哼哼]@2x.png",
	"./[右太极]@2x.png": "./src/assets/emoji/[右太极]@2x.png",
	"./[右车头]@2x.png": "./src/assets/emoji/[右车头]@2x.png",
	"./[吐]@2x.png": "./src/assets/emoji/[吐]@2x.png",
	"./[吓]@2x.png": "./src/assets/emoji/[吓]@2x.png",
	"./[咒骂]@2x.png": "./src/assets/emoji/[咒骂]@2x.png",
	"./[咖啡]@2x.png": "./src/assets/emoji/[咖啡]@2x.png",
	"./[啤酒]@2x.png": "./src/assets/emoji/[啤酒]@2x.png",
	"./[嘘]@2x.png": "./src/assets/emoji/[嘘]@2x.png",
	"./[回头]@2x.png": "./src/assets/emoji/[回头]@2x.png",
	"./[困]@2x.png": "./src/assets/emoji/[困]@2x.png",
	"./[坏笑]@2x.png": "./src/assets/emoji/[坏笑]@2x.png",
	"./[多云]@2x.png": "./src/assets/emoji/[多云]@2x.png",
	"./[大兵]@2x.png": "./src/assets/emoji/[大兵]@2x.png",
	"./[大哭]@2x.png": "./src/assets/emoji/[大哭]@2x.png",
	"./[太阳]@2x.png": "./src/assets/emoji/[太阳]@2x.png",
	"./[奋斗]@2x.png": "./src/assets/emoji/[奋斗]@2x.png",
	"./[奶瓶]@2x.png": "./src/assets/emoji/[奶瓶]@2x.png",
	"./[委屈]@2x.png": "./src/assets/emoji/[委屈]@2x.png",
	"./[害羞]@2x.png": "./src/assets/emoji/[害羞]@2x.png",
	"./[尴尬]@2x.png": "./src/assets/emoji/[尴尬]@2x.png",
	"./[左哼哼]@2x.png": "./src/assets/emoji/[左哼哼]@2x.png",
	"./[左太极]@2x.png": "./src/assets/emoji/[左太极]@2x.png",
	"./[左车头]@2x.png": "./src/assets/emoji/[左车头]@2x.png",
	"./[差劲]@2x.png": "./src/assets/emoji/[差劲]@2x.png",
	"./[弱]@2x.png": "./src/assets/emoji/[弱]@2x.png",
	"./[强]@2x.png": "./src/assets/emoji/[强]@2x.png",
	"./[彩带]@2x.png": "./src/assets/emoji/[彩带]@2x.png",
	"./[彩球]@2x.png": "./src/assets/emoji/[彩球]@2x.png",
	"./[得意]@2x.png": "./src/assets/emoji/[得意]@2x.png",
	"./[微笑]@2x.png": "./src/assets/emoji/[微笑]@2x.png",
	"./[心碎了]@2x.png": "./src/assets/emoji/[心碎了]@2x.png",
	"./[快哭了]@2x.png": "./src/assets/emoji/[快哭了]@2x.png",
	"./[怄火]@2x.png": "./src/assets/emoji/[怄火]@2x.png",
	"./[怒]@2x.png": "./src/assets/emoji/[怒]@2x.png",
	"./[惊恐]@2x.png": "./src/assets/emoji/[惊恐]@2x.png",
	"./[惊讶]@2x.png": "./src/assets/emoji/[惊讶]@2x.png",
	"./[憨笑]@2x.png": "./src/assets/emoji/[憨笑]@2x.png",
	"./[手枪]@2x.png": "./src/assets/emoji/[手枪]@2x.png",
	"./[打哈欠]@2x.png": "./src/assets/emoji/[打哈欠]@2x.png",
	"./[抓狂]@2x.png": "./src/assets/emoji/[抓狂]@2x.png",
	"./[折磨]@2x.png": "./src/assets/emoji/[折磨]@2x.png",
	"./[抠鼻]@2x.png": "./src/assets/emoji/[抠鼻]@2x.png",
	"./[抱抱]@2x.png": "./src/assets/emoji/[抱抱]@2x.png",
	"./[抱拳]@2x.png": "./src/assets/emoji/[抱拳]@2x.png",
	"./[拳头]@2x.png": "./src/assets/emoji/[拳头]@2x.png",
	"./[挥手]@2x.png": "./src/assets/emoji/[挥手]@2x.png",
	"./[握手]@2x.png": "./src/assets/emoji/[握手]@2x.png",
	"./[撇嘴]@2x.png": "./src/assets/emoji/[撇嘴]@2x.png",
	"./[擦汗]@2x.png": "./src/assets/emoji/[擦汗]@2x.png",
	"./[敲打]@2x.png": "./src/assets/emoji/[敲打]@2x.png",
	"./[晕]@2x.png": "./src/assets/emoji/[晕]@2x.png",
	"./[月亮]@2x.png": "./src/assets/emoji/[月亮]@2x.png",
	"./[棒棒糖]@2x.png": "./src/assets/emoji/[棒棒糖]@2x.png",
	"./[汽车]@2x.png": "./src/assets/emoji/[汽车]@2x.png",
	"./[沙发]@2x.png": "./src/assets/emoji/[沙发]@2x.png",
	"./[流汗]@2x.png": "./src/assets/emoji/[流汗]@2x.png",
	"./[流泪]@2x.png": "./src/assets/emoji/[流泪]@2x.png",
	"./[激动]@2x.png": "./src/assets/emoji/[激动]@2x.png",
	"./[灯泡]@2x.png": "./src/assets/emoji/[灯泡]@2x.png",
	"./[炸弹]@2x.png": "./src/assets/emoji/[炸弹]@2x.png",
	"./[熊猫]@2x.png": "./src/assets/emoji/[熊猫]@2x.png",
	"./[爆筋]@2x.png": "./src/assets/emoji/[爆筋]@2x.png",
	"./[爱你]@2x.png": "./src/assets/emoji/[爱你]@2x.png",
	"./[爱心]@2x.png": "./src/assets/emoji/[爱心]@2x.png",
	"./[爱情]@2x.png": "./src/assets/emoji/[爱情]@2x.png",
	"./[猪头]@2x.png": "./src/assets/emoji/[猪头]@2x.png",
	"./[猫咪]@2x.png": "./src/assets/emoji/[猫咪]@2x.png",
	"./[献吻]@2x.png": "./src/assets/emoji/[献吻]@2x.png",
	"./[玫瑰]@2x.png": "./src/assets/emoji/[玫瑰]@2x.png",
	"./[瓢虫]@2x.png": "./src/assets/emoji/[瓢虫]@2x.png",
	"./[疑问]@2x.png": "./src/assets/emoji/[疑问]@2x.png",
	"./[白眼]@2x.png": "./src/assets/emoji/[白眼]@2x.png",
	"./[皮球]@2x.png": "./src/assets/emoji/[皮球]@2x.png",
	"./[睡觉]@2x.png": "./src/assets/emoji/[睡觉]@2x.png",
	"./[磕头]@2x.png": "./src/assets/emoji/[磕头]@2x.png",
	"./[示爱]@2x.png": "./src/assets/emoji/[示爱]@2x.png",
	"./[礼品袋]@2x.png": "./src/assets/emoji/[礼品袋]@2x.png",
	"./[礼物]@2x.png": "./src/assets/emoji/[礼物]@2x.png",
	"./[篮球]@2x.png": "./src/assets/emoji/[篮球]@2x.png",
	"./[米饭]@2x.png": "./src/assets/emoji/[米饭]@2x.png",
	"./[糗大了]@2x.png": "./src/assets/emoji/[糗大了]@2x.png",
	"./[红双喜]@2x.png": "./src/assets/emoji/[红双喜]@2x.png",
	"./[红灯笼]@2x.png": "./src/assets/emoji/[红灯笼]@2x.png",
	"./[纸巾]@2x.png": "./src/assets/emoji/[纸巾]@2x.png",
	"./[胜利]@2x.png": "./src/assets/emoji/[胜利]@2x.png",
	"./[色]@2x.png": "./src/assets/emoji/[色]@2x.png",
	"./[药]@2x.png": "./src/assets/emoji/[药]@2x.png",
	"./[菜刀]@2x.png": "./src/assets/emoji/[菜刀]@2x.png",
	"./[蛋糕]@2x.png": "./src/assets/emoji/[蛋糕]@2x.png",
	"./[蜡烛]@2x.png": "./src/assets/emoji/[蜡烛]@2x.png",
	"./[街舞]@2x.png": "./src/assets/emoji/[街舞]@2x.png",
	"./[衰]@2x.png": "./src/assets/emoji/[衰]@2x.png",
	"./[西瓜]@2x.png": "./src/assets/emoji/[西瓜]@2x.png",
	"./[调皮]@2x.png": "./src/assets/emoji/[调皮]@2x.png",
	"./[象棋]@2x.png": "./src/assets/emoji/[象棋]@2x.png",
	"./[跳绳]@2x.png": "./src/assets/emoji/[跳绳]@2x.png",
	"./[跳跳]@2x.png": "./src/assets/emoji/[跳跳]@2x.png",
	"./[车厢]@2x.png": "./src/assets/emoji/[车厢]@2x.png",
	"./[转圈]@2x.png": "./src/assets/emoji/[转圈]@2x.png",
	"./[鄙视]@2x.png": "./src/assets/emoji/[鄙视]@2x.png",
	"./[酷]@2x.png": "./src/assets/emoji/[酷]@2x.png",
	"./[钞票]@2x.png": "./src/assets/emoji/[钞票]@2x.png",
	"./[钻戒]@2x.png": "./src/assets/emoji/[钻戒]@2x.png",
	"./[闪电]@2x.png": "./src/assets/emoji/[闪电]@2x.png",
	"./[闭嘴]@2x.png": "./src/assets/emoji/[闭嘴]@2x.png",
	"./[闹钟]@2x.png": "./src/assets/emoji/[闹钟]@2x.png",
	"./[阴险]@2x.png": "./src/assets/emoji/[阴险]@2x.png",
	"./[难过]@2x.png": "./src/assets/emoji/[难过]@2x.png",
	"./[雨伞]@2x.png": "./src/assets/emoji/[雨伞]@2x.png",
	"./[青蛙]@2x.png": "./src/assets/emoji/[青蛙]@2x.png",
	"./[面条]@2x.png": "./src/assets/emoji/[面条]@2x.png",
	"./[鞭炮]@2x.png": "./src/assets/emoji/[鞭炮]@2x.png",
	"./[风车]@2x.png": "./src/assets/emoji/[风车]@2x.png",
	"./[飞吻]@2x.png": "./src/assets/emoji/[飞吻]@2x.png",
	"./[飞机]@2x.png": "./src/assets/emoji/[飞机]@2x.png",
	"./[饥饿]@2x.png": "./src/assets/emoji/[饥饿]@2x.png",
	"./[香蕉]@2x.png": "./src/assets/emoji/[香蕉]@2x.png",
	"./[骷髅]@2x.png": "./src/assets/emoji/[骷髅]@2x.png",
	"./[麦克风]@2x.png": "./src/assets/emoji/[麦克风]@2x.png",
	"./[麻将]@2x.png": "./src/assets/emoji/[麻将]@2x.png",
	"./[鼓掌]@2x.png": "./src/assets/emoji/[鼓掌]@2x.png",
	"./[龇牙]@2x.png": "./src/assets/emoji/[龇牙]@2x.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/emoji sync recursive ^\\.\\/.*@2x\\.png$";